import { ColumnsType } from "antd/es/table";

import { PaymentTypeRecord } from "./types";

export const defaultColumns: ColumnsType<PaymentTypeRecord> = [
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 150,
  },
  {
    title: "Usage Type",
    dataIndex: "usageType",
    key: "usageType",
    width: 100,
    render: (_, record) => record.propertyLabels?.usageType ?? record.usageType,
  },
  {
    title: "VAT Rate",
    dataIndex: "vatInPercentage",
    key: "vatInPercentage",
    width: 70,
  },
  {
    title: "Payment Mode",
    dataIndex: "modeOfPayment",
    key: "modeOfPayment",
    width: 100,
    render: (_, record) => record.propertyLabels?.modeOfPayment ?? record.modeOfPayment,
  },
  {
    title: "Payment Type",
    dataIndex: "paymentType",
    key: "paymentType",
    width: 100,
    render: (_, record) => record.propertyLabels?.paymentType ?? record.paymentType,
  },
  {
    title: "Amount / %",
    dataIndex: "defaultAmount",
    key: "defaultAmount",
    width: 100,
  },
  {
    title: "Lease Type",
    dataIndex: "leaseType",
    key: "leaseType",
    width: 100,
    render: (_, record) => record.propertyLabels?.leaseType ?? record.leaseType,
  },
  {
    title: "Pattern",
    dataIndex: "pattern",
    key: "pattern",
    width: 100,
    render: (_, record) => record.propertyLabels?.pattern ?? record.pattern,
  },
  {
    title: "Is Upfront Payment",
    dataIndex: "isUpfrontPayment",
    key: "isUpfrontPayment",
    width: 100,
    render: (_, record) => record.propertyLabels?.isUpfrontPayment ?? record.isUpfrontPayment,
  },
  {
    title: "Is Write-Off",
    dataIndex: "isWriteOff",
    key: "isWriteOff",
    width: 100,
    render: (_, record) => record.propertyLabels?.isWriteOff ?? record.isWriteOff,
  },
];
